/* Creme Castle — product-page delivery picker (Step 2, Sept 2026).
 *
 * Replaces the tag-driven filterSlotsForToday / filter2HourSlots / filter3HourSlots /
 * filterFaridabadSlots block. Draws the same city → area → day tabs → time pills UI,
 * but every decision comes from CCSlotEngine using the product's delivery rule
 * (window.ccProduct.rule, from the delivery.rule metafield) and the city's
 * metaobject (window.ccSlotData.cities). Writes REAL values into the cart line:
 *   properties[Day]  = YYYY-MM-DD (the OMS already resolves ISO dates first)
 *   properties[Time] = the city grid's own label, e.g. "3PM–5PM"
 *   properties[_rule] = rule handle, so the cart guard and the OMS can re-check
 *   properties[_flavor_rule] = "skipped" when the flavour rule removed a window
 *
 * Flavour rule (Pranjay, 4 Sep 2026): on custom cakes (SKU starts with C or B), a
 * flavour outside rule.transit_safe_flavors cannot take the FIRST same-day window.
 * Both directions fade: pick such a flavour and the first slot greys out; pick the
 * first slot and the other flavours grey out. On a conflict the slot gives way.
 * Only today is affected — when the first offered slot is tomorrow, all flavours go.
 *
 * DOM contract (unchanged from the old picker so CSS keeps working):
 *   select#location, select#areaDropdown, input#areaOther, #areaMicro
 *   .tabs-master-container  .tab[data-tab=today|tomorrow|earliest|calendar]
 *   #time-slot-today #time-slot-tomorrow #time-slot-earliest #time-slot-calendar
 *   input#datepickerr  #calendar-slots  #note
 *   hidden inputs #Day #Time #Delivery #city #area-sector #cc-rule
 *   variant-radios / variant-selects (Dawn) for the flavour choice
 */
(function () {
  "use strict";
  var E = window.CCSlotEngine, D = window.ccSlotData, P = window.ccProduct || {};
  if (!E || !D) { console.error("[cc-slot] engine/data missing"); return; }

  var rule = (D.rules && D.rules[P.rule]) || null;
  if (!rule) {
    // No rule on the product (11 known placeholders): fall back to designer, the
    // safest default, and say so in the console for QA.
    rule = D.rules && D.rules.designer;
    console.warn("[cc-slot] product has no delivery rule; using designer", P);
  }
  var cityAreaData = window.ccCityAreas || {};

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var el = {
    tabs: $(".tabs-master-container"),
    today: $("#time-slot-today"), tomorrow: $("#time-slot-tomorrow"), earliest: $("#time-slot-earliest"),
    calendar: $("#time-slot-calendar"), calSlots: $("#calendar-slots"), date: $("#datepickerr"),
    tabToday: $('.tab[data-tab="today"]'), tabTomorrow: $('.tab[data-tab="tomorrow"]'),
    tabEarliest: $('.tab[data-tab="earliest"]'), tabCalendar: $('.tab[data-tab="calendar"]'),
    note: $("#note"),
    Day: $("#Day"), Time: $("#Time"), Delivery: $("#Delivery"), city: $("#city"), area: $("#area-sector"), ruleIn: $("#cc-rule"),
    location: $("#location"), areaSel: $("#areaDropdown"), areaOther: $("#areaOther"), areaMicro: $("#areaMicro")
  };
  if (!el.location || !el.tabs) return;

  var state = { city: null, cityName: "", plan: null, dayByTab: {}, activeTab: "", timer: null, lockedToday: "" };

  /* ---------- product facts: custom cake? which flavour? ---------- */
  function variantsJson() {
    var s = $('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    try { return s ? JSON.parse(s.textContent) : []; } catch (e) { return []; }
  }
  var variants = variantsJson();
  // Custom cake = SKU starts with C (C0004_1, C5231_3 …) or B (bento, B0001_1). Classic Z*, add-ons etc. are not.
  var customCake = variants.some(function (v) { return /^[CB]/i.test(v.sku || ""); });
  var FLAVOR_NAME = /flavou?r|top tier|bottom tier/i;
  // Currently chosen flavour values (radios or dropdowns), only for flavour-type options.
  function chosenFlavors() {
    var out = [];
    document.querySelectorAll('variant-radios input[type="radio"]:checked').forEach(function (r) { if (FLAVOR_NAME.test(r.name)) out.push(r.value); });
    document.querySelectorAll('variant-selects select').forEach(function (s) { if (FLAVOR_NAME.test(s.name) && s.value) out.push(s.value); });
    return out;
  }
  function flavorRuleOn() { return E.flavorRuleActive(rule, { customCake: customCake, flavors: chosenFlavors() }); }
  function pickerOpts() { return { preorderFrom: P.preorderFrom || "", skipFirstToday: flavorRuleOn() }; }
  var SAFE_LIST = E.normRule(rule).transit_safe_flavors;

  /* ---------- writing the cart line ---------- */
  // Anchor on the form that already holds #Day: Dawn renders a Shop Pay
  // installment form that also matches form[action*="/cart/add"][id^="product-form-"]
  // and comes first in the DOM, and properties added to that form are never sent.
  var addForm = (el.Day && el.Day.closest("form")) ||
    $('form[action*="/cart/add"]:not([id*="installment"])') || $('product-form form[action*="/cart/add"]');
  var flavorRuleIn = null;
  var dayLabelIn = null;
  if (addForm) {
    flavorRuleIn = addForm.querySelector('input[name="properties[_flavor_rule]"]');
    if (!flavorRuleIn) { flavorRuleIn = document.createElement("input"); flavorRuleIn.type = "hidden"; flavorRuleIn.name = "properties[_flavor_rule]"; flavorRuleIn.value = ""; addForm.appendChild(flavorRuleIn); }
    // Human-readable twin of Day for the WhatsApp confirmation ("Sun, 20 Sep").
    // Day itself stays the ISO date the OMS parses. No underscore, so it shows
    // to the customer; sits straight after Cake Message in the property list.
    dayLabelIn = addForm.querySelector('input[name="properties[Delivery Day]"]');
    if (!dayLabelIn) {
      dayLabelIn = document.createElement("input");
      dayLabelIn.type = "hidden"; dayLabelIn.name = "properties[Delivery Day]"; dayLabelIn.value = "";
      var msgIn = addForm.querySelector('input[name="properties[Cake Message]"], textarea[name="properties[Cake Message]"]');
      if (msgIn && msgIn.parentNode) msgIn.parentNode.insertBefore(dayLabelIn, msgIn.nextSibling);
      else addForm.appendChild(dayLabelIn);
    }
  }
  function setChoice(ymd, slot) {
    if (el.Day) el.Day.value = ymd || "";
    if (el.Time) el.Time.value = slot || "";
    if (el.ruleIn) el.ruleIn.value = rule.handle;
    // Legacy field the OMS still shows: designer cakes ride "Standard", the rest "Fixed Time".
    if (el.Delivery) el.Delivery.value = rule.handle === "designer" ? "Standard Delivery" : "Fixed Time Delivery";
    // Same date, spelled for a person. E.labelShort keeps it identical to the day tab.
    if (dayLabelIn) dayLabelIn.value = ymd ? E.labelShort(ymd) : "";
    // Tell the OMS when the flavour rule moved this order off the first window.
    if (flavorRuleIn) flavorRuleIn.value = (slot && flavorRuleOn() && state.lockedToday) ? "skipped" : "";
  }
  function clearTime() { if (el.Time) el.Time.value = ""; }

  /* ---------- rendering ---------- */
  var CSS = ".slot.slot--locked{opacity:.38;cursor:not-allowed;box-shadow:none;border-style:dashed}" +
    ".cc-fl-locked{opacity:.38;pointer-events:none}.cc-fl-locked label{cursor:not-allowed}" +
    ".cc-fl-note{font-size:12px;color:#7E6B6E;margin:2px 0 8px;font-family:'Montserrat',sans-serif}";
  (function () { var s = document.createElement("style"); s.textContent = CSS; document.head.appendChild(s); })();
  var LOCK_NOTE = "Not available for this flavour — non-chocolate cakes need a later slot for safe transit.";

  function pills(container, ymd, windows, lockedLabel) {
    container.classList.add("tab-content");
    container.innerHTML = "";
    if (!windows.length) { container.innerHTML = "<p>No available slots.</p>"; return; }
    windows.forEach(function (label) {
      var s = document.createElement("div");
      var locked = lockedLabel && E.slotKey(label) === E.slotKey(lockedLabel);
      s.className = "slot" + (locked ? " slot--locked" : ""); s.textContent = label; s.dataset.ymd = ymd; s.dataset.slot = label;
      if (locked) { s.title = LOCK_NOTE; s.setAttribute("aria-disabled", "true"); }
      s.onclick = function () {
        if (locked) return;
        container.querySelectorAll(".slot").forEach(function (x) { x.classList.remove("active"); });
        s.classList.add("active");
        setChoice(ymd, label);
        fadeFlavors();
      };
      container.appendChild(s);
    });
  }
  function show(node, on, display) { if (node) node.style.display = on ? (display || "inline-block") : "none"; }

  // Reverse direction: when the FIRST same-day window is the chosen slot, the
  // non-safe flavour options fade (custom cakes only, rule on).
  function fadeFlavors() {
    var lock = !!(customCake && E.normRule(rule).skip_first_slot && SAFE_LIST.length && state.lockedToday &&
      el.Day && el.Day.value === (state.dayByTab.today || "") && el.Time && E.slotKey(el.Time.value) === E.slotKey(state.lockedToday));
    document.querySelectorAll('variant-radios input[type="radio"]').forEach(function (r) {
      if (!FLAVOR_NAME.test(r.name)) return;
      var unsafe = !E.isSafeFlavor(rule, r.value);
      var wrap = r.closest(".flavor-sliderrr") || r.parentNode;
      var on = lock && unsafe;
      wrap.classList.toggle("cc-fl-locked", on);
      if (on) { r.disabled = true; wrap.title = LOCK_NOTE; } else if (r.disabled && wrap.dataset.ccLocked === "1") { r.disabled = false; wrap.removeAttribute("title"); }
      wrap.dataset.ccLocked = on ? "1" : "";
    });
    document.querySelectorAll("variant-selects select").forEach(function (s) {
      if (!FLAVOR_NAME.test(s.name)) return;
      Array.prototype.forEach.call(s.options, function (o) { o.disabled = lock && !E.isSafeFlavor(rule, o.value); });
    });
    var fs = document.querySelector('variant-radios fieldset legend, variant-selects label');
    var note = document.getElementById("cc-fl-note");
    if (lock) {
      if (!note && fs) { note = document.createElement("div"); note.id = "cc-fl-note"; note.className = "cc-fl-note"; fs.parentNode.insertBefore(note, fs.nextSibling); }
      if (note) note.textContent = "First slot of the day: chocolate flavours only (they travel safely on a short lead). Pick a later slot for the others.";
    } else if (note) note.remove();
  }

  function setActiveTab(tab) {
    state.activeTab = tab;
    document.querySelectorAll(".tab").forEach(function (t) { t.classList.toggle("active", t.dataset.tab === tab); });
    ["today", "tomorrow", "earliest"].forEach(function (k) { show(el[k], k === tab, "flex"); });
    show(el.calendar, tab === "calendar", "block");
    var active = tab === "calendar" ? el.calSlots : el[tab];
    if (active) active.querySelectorAll(".slot").forEach(function (x) { x.classList.remove("active"); });
    clearTime();
    if (tab === "calendar") {
      setChoice(el.date && el.date.value ? el.date.value : "", "");
    } else {
      setChoice(state.dayByTab[tab] || "", "");
      if (el.date) el.date.value = "";
      if (el.calSlots) el.calSlots.innerHTML = "";
    }
    fadeFlavors();
  }

  function renderCalendarDay(ymd) {
    var now = window.ccClock.now();
    var w = ymd ? E.windowsFor(rule, state.city, ymd, now, pickerOpts()) : [];
    pills(el.calSlots, ymd, w);
    if (ymd && !w.length) el.calSlots.innerHTML = "<p>No delivery on that date. Please choose another.</p>";
    setChoice(ymd, "");
  }

  function noteText(plan) {
    var n = state.city.windows.length;
    var grid = n === 7 ? "2-hour" : n === 4 ? "3-hour" : "fixed";
    var base = state.cityName + " delivers in " + grid + " windows.";
    var fl = (state.lockedToday && flavorRuleOn()) ? " The " + state.lockedToday + " window is not available for " + chosenFlavors().filter(function (f) { return !E.isSafeFlavor(rule, f); }).join(" / ") + " — non-chocolate cakes need a later slot for safe transit." : "";
    if (plan.preorderMode) return { head: "Pre-order", body: "The earliest we can deliver is " + plan.earliestLong + ". " + base + " Pick a delivery day above, then a time window." };
    if (rule.family === "cutoff") return { head: "", body: base + " This cake is baked to order and delivered from " + plan.earliestLong + " — order by " + (E.normRule(rule).cutoff_hour > 12 ? (E.normRule(rule).cutoff_hour - 12) + " PM" : E.normRule(rule).cutoff_hour + " AM") + " for next-day delivery." };
    if (!state.city.same_day_allowed) return { head: "", body: base + " We deliver to " + state.cityName + " next day onwards." };
    return { head: "", body: base + " Today’s windows narrow through the day as the cutoff nears." + fl };
  }

  function render() {
    if (!state.city) return;
    var now = window.ccClock.now();
    var base = pickerOpts(); base.skipFirstToday = false;
    // Draw from the full plan so the first window is visible (faded), but decide
    // offerability with the flavour rule applied.
    var full = E.plan(rule, state.city, now, base);
    var plan = E.plan(rule, state.city, now, pickerOpts());
    var todayFull = full.days.filter(function (d) { return d.tab === "today"; })[0];
    state.lockedToday = (customCake && E.normRule(rule).skip_first_slot && SAFE_LIST.length && todayFull && todayFull.windows.length) ? todayFull.windows[0] : "";
    var lockLabel = flavorRuleOn() ? state.lockedToday : "";
    state.plan = plan; state.dayByTab = {};
    ["today", "tomorrow", "earliest"].forEach(function (k) { show(el["tab" + k[0].toUpperCase() + k.slice(1)], false); show(el[k], false); });
    var firstTab = null;
    full.days.forEach(function (d) {
      state.dayByTab[d.tab] = d.ymd;
      var tab = el["tab" + d.tab[0].toUpperCase() + d.tab.slice(1)];
      if (d.tab === "earliest" && tab) tab.textContent = d.label;
      show(tab, true);
      pills(el[d.tab], d.ymd, d.windows, d.tab === "today" ? lockLabel : "");
      var offerable = d.windows.filter(function (w) { return !(d.tab === "today" && lockLabel && E.slotKey(w) === E.slotKey(lockLabel)); }).length;
      if (!firstTab && offerable) firstTab = d.tab;
    });
    if (el.date) { el.date.min = plan.calendarMin; el.date.removeAttribute("name"); }
    if (el.note) {
      var t = noteText(plan);
      if (el.note.parentNode !== el.tabs) el.tabs.appendChild(el.note);
      el.note.textContent = "";
      if (t.head) { var b = document.createElement("strong"); b.textContent = t.head; el.note.appendChild(b); el.note.appendChild(document.createElement("br")); }
      el.note.appendChild(document.createTextNode(t.body));
      el.note.style.display = "block";
    }
    // Keep the shopper's tab if it still exists, else the first useful one.
    var keep = state.activeTab && (state.dayByTab[state.activeTab] || state.activeTab === "calendar");
    setActiveTab(keep ? state.activeTab : (firstTab || "calendar"));
  }

  /* ---------- wiring ---------- */
  function populateAreas(name) {
    var dd = el.areaSel; if (!dd) return;
    if (el.areaOther) { el.areaOther.style.display = "none"; el.areaOther.value = ""; }
    var has = name && cityAreaData[name];
    dd.innerHTML = '<option value="">Select Area / Sector</option>' + (has ? '<option value="__other__">✎ Can’t find your area? Type it</option>' : "");
    if (el.areaMicro) el.areaMicro.style.display = has ? "block" : "none";
    if (!has) return;
    cityAreaData[name].forEach(function (a) { var o = document.createElement("option"); o.value = a; o.textContent = a; dd.appendChild(o); });
  }

  el.location.addEventListener("change", function (e) {
    var name = e.target.value;
    if (el.city) el.city.value = name || "";
    populateAreas(name);
    el.tabs.style.display = "none";
    setChoice("", "");
    // Normalise once: the raw metaobject record has slot_windows/strings, the engine
    // and noteText() expect windows/numbers.
    state.city = name && D.cities[name] ? E.normCity(D.cities[name]) : null;
    state.cityName = name;
    state.activeTab = "";
    if (!state.city) { if (name) console.warn("[cc-slot] unknown city", name); return; }
    window.ccClock.sync().then(render);
  });

  if (el.areaSel) el.areaSel.addEventListener("change", function (e) {
    var v = e.target.value;
    if (v === "__other__") {
      if (el.areaOther) { el.areaOther.style.display = "block"; el.areaOther.value = ""; el.areaOther.focus(); }
      if (el.area) el.area.value = ""; el.tabs.style.display = "none"; return;
    }
    if (el.areaOther) { el.areaOther.style.display = "none"; el.areaOther.value = ""; }
    if (el.area) el.area.value = v || "";
    el.tabs.style.display = v ? "block" : "none";
    if (v) window.ccClock.sync().then(render);
  });
  if (el.areaOther) el.areaOther.addEventListener("input", function () {
    var t = el.areaOther.value.trim();
    if (el.area) el.area.value = t.length >= 3 ? t : "";
    el.tabs.style.display = t.length >= 3 ? "block" : "none";
    if (t.length >= 3) window.ccClock.sync().then(render);
  });

  // Flavour changed: re-draw. A chosen slot that is now locked gives way (B1).
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (!t || !FLAVOR_NAME.test(t.name || "")) return;
    if (!t.closest || !t.closest("variant-radios, variant-selects")) return;
    if (!state.city || el.tabs.style.display === "none") return;
    var keepTime = el.Time ? el.Time.value : "", keepDay = el.Day ? el.Day.value : "";
    render();
    // render() clears the time; restore it if the pair is still allowed.
    if (keepTime && keepDay && E.isOfferable(rule, state.city, keepDay, keepTime, window.ccClock.now(), pickerOpts())) {
      var panel = state.activeTab === "calendar" ? el.calSlots : el[state.activeTab];
      if (panel) panel.querySelectorAll(".slot").forEach(function (x) { if (E.slotKey(x.dataset.slot) === E.slotKey(keepTime)) x.click(); });
    }
  }, true);

  document.querySelectorAll(".tab").forEach(function (btn) {
    btn.addEventListener("click", function () { setActiveTab(btn.dataset.tab); });
  });
  if (el.date) el.date.addEventListener("change", function () {
    var v = el.date.value;
    if (v && state.plan && v < state.plan.calendarMin) {
      alert("Sorry, that date is too early. The earliest we can deliver is " + state.plan.earliestLong + ".");
      el.date.value = ""; renderCalendarDay(""); return;
    }
    renderCalendarDay(v);
  });

  // Windows expire while the page sits open: re-draw once a minute and drop
  // anything that has slipped past its cutoff.
  state.timer = setInterval(function () { if (state.city && el.tabs.style.display !== "none") render(); }, 60000);

  // Final say before the line goes to the cart. Returns "" when OK, else the message.
  window.ccPickerValidate = function () {
    if (!el.city || !el.city.value) return "Please select your city, area, date and time slot to proceed.";
    if (!el.area || !el.area.value) return "Please select your area / sector.";
    var ymd = el.Day ? el.Day.value : "", slot = el.Time ? el.Time.value : "";
    if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd) || !slot) return "Please choose a delivery day and time slot.";
    var now = window.ccClock.now();
    if (!E.isOfferable(rule, state.city, ymd, slot, now, pickerOpts())) {
      var wasFlavor = E.isOfferable(rule, state.city, ymd, slot, now, { preorderFrom: P.preorderFrom || "" });
      render();
      return wasFlavor ? "That slot isn’t available for this flavour. Please pick a later window or a chocolate flavour." : "That time slot has just closed. Please pick another.";
    }
    return "";
  };
})();